const collectFirstString = (value) => {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const found = collectFirstString(item);
      if (found) {
        return found;
      }
    }
    return "";
  }

  if (typeof value === "object") {
    if (typeof value.onlyvalue === "string" && value.onlyvalue) {
      return value.onlyvalue;
    }

    for (const key of Object.keys(value)) {
      const found = collectFirstString(value[key]);
      if (found) {
        return found;
      }
    }
  }

  return "";
};

export const getReadableErrorMessage = (error) => {
  const body = error?.body || {};
  const bodyErrors = body.errors;
  const bodyMessage = body.message;

  if (typeof bodyErrors === "string" && bodyErrors) {
    return bodyErrors;
  }

  const flattenedError = collectFirstString(bodyErrors);
  if (flattenedError) {
    return flattenedError;
  }

  if (typeof bodyMessage === "string" && bodyMessage && bodyMessage !== "error when validate") {
    return bodyMessage;
  }

  if (typeof error?.message === "string" && error.message) {
    if (error.message === "error when validate") {
      return "Validation failed";
    }
    return error.message;
  }

  return "Unknown error";
};
